import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { homePathForUser } from '../utils/roles.js';

/**
 * @param {{
 *   capability: string,
 *   redirectTo?: string,
 *   children: import('react').ReactNode,
 * }} props
 */
export function FeatureGate({ capability, redirectTo, children }) {
  const { user } = useAuth();
  const fallback = redirectTo ?? homePathForUser(user);

  if (!user?.capabilities?.[capability]) {
    return <Navigate to={fallback} replace />;
  }

  return children;
}
